import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const path = mode === "login" ? "/auth/login" : "/auth/register";
      const { data } = await api.post(path, form);
      login(data);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-app flex flex-col items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <img src="/studio83-logo.png" alt="Studio 83" className="h-9 w-auto mb-3" style={{ filter: "brightness(0)" }} />
        <p className="text-subtle text-sm mb-10">Planificación y aprobación de contenido.</p>

        <form onSubmit={submit} className="space-y-4" data-testid="auth-form">
          {mode === "register" && (
            <Field label="Nombre" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="name-input" />
          )}
          <Field label="Correo" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="email-input" />
          <Field label="Contraseña" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="password-input" />

          {error && <p className="text-sm text-changes" data-testid="auth-error">{error}</p>}

          <button type="submit" disabled={busy} data-testid="auth-submit" className="w-full py-2.5 bg-ink text-white text-sm rounded-sm disabled:opacity-50">
            {busy ? "Un momento…" : mode === "login" ? "Entrar" : "Crear cuenta"}
          </button>
        </form>

        <button
          onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
          className="text-sm text-subtle mt-6 hover:text-ink"
          data-testid="auth-toggle"
        >
          {mode === "login" ? "¿No tienes cuenta? Créala" : "Ya tengo cuenta"}
        </button>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, testid }) {
  return (
    <label className="block">
      <span className="text-sm text-subtle">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        data-testid={testid}
        className="mt-1 w-full border border-line rounded-sm px-3 py-2.5 text-sm bg-surface focus:outline-none"
      />
    </label>
  );
}
